import React, { Component } from 'react'
import CustomModal from './index';
import {ColorButton} from '../../../../index';
import Autoload from "../../../../Autoload";
import { Group, Stack } from '@mantine/core';
import { connect } from 'react-redux';
import visa from '../../../../../assets/images/module/general/visa.svg';
import mastercard from '../../../../../assets/images/module/general/mastercard.svg';
import amex from '../../../../../assets/images/module/general/amex.svg';
import paypal from '../../../../../assets/images/module/general/paypal.svg';
import StarterBadgeIcon from '../../../../../assets/images/module/general/StarterBadgeIcon.svg';
import PremiumBadgeIcon from '../../../../../assets/images/module/general/PremiumBadgeIcon.svg';
import ProfessionalBadgeIcon from '../../../../../assets/images/module/general/ProfessionalBadgeIcon.svg';
import { formatNumber } from '../../../../../helpers/stringsManipulations';
import moment from 'moment';
import dayjs from 'dayjs';
import accounting from 'accounting';
import SubscriptionBadgeIcon from '../../../SVGs/SubscriptionBadgeIcon';
import {
    isAnnualSubscription,
    getMonthlyEquivalentPrice,
    isSubscriptionSwitchADowngrade,
    getBillingPeriodLabel,
    getBillingPeriodSuffix,
} from '../../../../../helpers/subscriptionBilling';
import { getSubscriptionTier, isProfessionalTier } from '../../../../../helpers/subscriptionFeatureAccess';
import AnnualBillingSummary from '../../../../../components/AnnualBillingSummary';

var Setting = Autoload.Setting;
var lang = Setting[Setting.language_default];

class PaymentConfirmationModal extends Component {
    state={
        holderName: '',
        holderCardNo: '',
        isDowngrade: false
    }
    constructor(props){
        super(props);
    }

    componentDidMount(){
        this.getPaymentDetails();
        this.setIsDowngrade();
    }

    componentDidUpdate(prevProps){
        if(prevProps.subscriptionTypes.length !== this.props.subscriptionTypes.length){
            this.setIsDowngrade();
        }
    }

    setIsDowngrade=()=>{
        const {currentSubscription, subscriptionTypes, subscribtionSelected} = this.props;

        let selectedSubscription = subscriptionTypes.find((subscriptionType)=> subscriptionType?.subscriptionTypeId === subscribtionSelected);
        console.log('selectedSubscription: ', selectedSubscription, subscribtionSelected, subscriptionTypes);
        // Covers monthly<->annual switches too (always upgrade/downgrade "no exception" per the
        // annual-plans ticket) as well as the pre-existing monthly tier-based rule - see
        // isSubscriptionSwitchADowngrade in helpers/subscriptionBilling.js.
        this.setState({isDowngrade: isSubscriptionSwitchADowngrade(currentSubscription, selectedSubscription)});
    }

    getPaymentDetails = () => {
        console.log('this.props.profile', this.props.profile.accountId, this.props.profile);
        const userAccountID = this.props.profile.accountId;
        // console.log(userAccountID, 'userAccountID from redux - payment details page');
        Autoload.HttpRequestAxios.HttpRequest(
          Autoload.Setting.account_api_baseurl + userAccountID + '/paymentMandate',
          'GET',
          null,
          null,
          false,
          true,
          false,
          this,
          'handle_account_payment_details',
          null,
          false,
          '',
          {
            Authorization: Autoload.Utils.getAuthToken(),
          }
        );
      };
      handle_account_payment_details(response) {
        console.log('handle_account_payment_details response', response);
        if (response.status == true && response.statuscode == 200) {
          this.setState({
            holderName: Autoload.MainHelper.checkProperty(response.result, 'holderName'),
            holderCardNo: Autoload.MainHelper.checkProperty(response.result, 'holderAccount'),
            consumerAccount: Autoload.MainHelper.checkProperty(response.result, 'consumerAccount'),
            consumerBic: Autoload.MainHelper.checkProperty(response.result, 'consumerBic'),
            cardNumber: Autoload.MainHelper.checkProperty(response.result, 'cardNumber'),
            cardLabel: Autoload.MainHelper.checkProperty(response.result, 'cardLabel'),
            cardExpiryDate: Autoload.MainHelper.checkProperty(response.result, 'cardExpiryDate'),
            accountCreated: moment(Autoload.MainHelper.checkProperty(response.result, 'createdAt')).format('DD.MM.YYYY'),
            accountStatus: Autoload.MainHelper.checkProperty(response.result, 'mandateStatus'),
            heading: Autoload.MainHelper.checkProperty(response.result, 'paymentMethod'),
          });
        }

        window.Intercom("update", {
            "Payment method": response?.result?.paymentMethod ? (response?.result?.isManuallyCreated && response?.result?.paymentMethod === 'directdebit') ? 'directdebit-hh' : response?.result?.paymentMethod : 'none',
            "Payment mandate id": response?.result?.paymentMandateid ? response?.result?.paymentMandateid : 'none'
          });
      }
    // "Premium-Abonnement (jährliche Abrechnung)", bold like on the Abonnements view: the plan's
    // name, while the billing period stays in regular weight.
    renderPlanName = (subscription, genitive = false) => (
        <>
            <span style={{fontWeight: 'bold'}}>{subscription?.subscriptionName}-Abonnement{genitive ? 's' : ''}</span>
            {` ${getBillingPeriodSuffix(subscription)}`}
        </>
    );

    // Amount + frequency phrase for the confirmation text. Annual plans are invoiced once a
    // year for the full yearly amount, not "jeden Monat" like the existing monthly plans.
    renderDeductionText = (subscriptionType) => (
        <>
            <span style={{fontWeight: 'bold'}}>{accounting.formatMoney(subscriptionType.price, '€', 2, '.', ',', '%v %s')}</span>
            {isAnnualSubscription(subscriptionType) ? ' werden einmal jährlich' : ' werden jeden Monat'} von Ihrem Zahlungsmittel eingezogen
        </>
    );

    getCancellationText = (subscriptionType) => {
        if (isAnnualSubscription(subscriptionType)) return 'Jährliche Kündigung möglich.';
        return `${subscriptionType.cancellation === 'monthly' ? 'Monatliche' : 'täglich'} Kündigung möglich.`;
    }

    // What happens when the chosen plan is confirmed. The plan after the trial starts the day after
    // the trial's last day. A downgrade (see isSubscriptionSwitchADowngrade) starts on the current
    // plan's renewal date, an upgrade today (annual plans, case 1: switches immediately with a
    // credit invoice).
    renderChangeText = (subscriptionType) => {
        const {currentSubscription, hasTested} = this.props;
        const {isDowngrade} = this.state;
        const isTrial = currentSubscription?.subscriptionTypeId === '97f226d5-a137-48e6-aa9a-605d4488dec7';
        const deduction = this.renderDeductionText(subscriptionType);
        const cancellation = this.getCancellationText(subscriptionType);

        if ((currentSubscription === null && !hasTested) || (isProfessionalTier(currentSubscription) && isTrial)) {
            const trialEnd = currentSubscription ? currentSubscription.subscriptionEndDate : dayjs().add(30, 'days').format('DD.MM.YYYY');
            const startDate = currentSubscription ? dayjs(currentSubscription.subscriptionEndDate, 'DD.MM.YYYY').add(1, 'day').format('DD.MM.YYYY') : dayjs().add(31, 'days').format('DD.MM.YYYY');
            return <>Sie testen hellohousing noch kostenlos und unverbindlich bis zum <span style={{fontWeight: 'bold'}}>{trialEnd}</span>. Im Anschluss wechseln Sie zum {this.renderPlanName(subscriptionType)}. {deduction}. Beginn der Laufzeit am <span style={{fontWeight: 'bold'}}>{startDate}</span>. {cancellation}</>;
        }
        if (isDowngrade) {
            const renewDate = currentSubscription?.subscriptionRenewDate;
            return <>Nach Ablauf Ihres aktuellen {this.renderPlanName(currentSubscription, true)} am <span style={{fontWeight: 'bold'}}>{renewDate}</span> wechseln Sie zum {this.renderPlanName(subscriptionType)}. {deduction}. Beginn der Laufzeit am <span style={{fontWeight: 'bold'}}>{renewDate}</span>. {cancellation}</>;
        }
        return <>Sie wechseln zum {this.renderPlanName(subscriptionType)}. {deduction}. Beginn der Laufzeit am <span style={{fontWeight: 'bold'}}>{moment().format('DD.MM.YYYY')}</span>. {cancellation}</>;
    }

    // Headline price (always the monthly-equivalent, so Starter/Premium/Professional stay
    // comparable) plus the billing period below it: for annual plans the yearly total and the
    // savings vs. paying monthly, for monthly plans "Monatliche Abrechnung".
    // The badge sits in the price row, so it lines up with the price rather than the whole block.
    renderPriceBlock = (subscriptionType) => {
        const { subscriptionTypes } = this.props;
        const monthlyEquivalent = getMonthlyEquivalentPrice(subscriptionType);
        const [euros, cents] = monthlyEquivalent.toFixed(2).split('.');
        return (
            <Stack gap={2} style={{width: '100%'}}>
                <Group justify={'space-between'} align={'center'} wrap={'nowrap'}>
                    <Group align={'center'} gap={0}>
                        <span className='upgrade-subscription-card-value'>{euros}<span style={{fontSize: '13px'}}>{monthlyEquivalent > 0 && cents}</span>€</span>
                        <span className='upgrade-subscription-card-monat'> / {subscriptionType.billing === 'daily' ? 'täglich' : 'Monat'}</span>
                    </Group>
                    <SubscriptionBadgeIcon name={subscriptionType?.name} category={getSubscriptionTier(subscriptionType)}/>
                </Group>
                {isAnnualSubscription(subscriptionType) ?
                <AnnualBillingSummary className='upgrade-subscription-card-monat' style={{marginLeft: 0}} subscriptionType={subscriptionType} subscriptionTypes={subscriptionTypes}/>
                :
                <span className='upgrade-subscription-card-monat' style={{marginLeft: 0}}>{getBillingPeriodLabel(subscriptionType)}</span>}
            </Stack>
        );
    }

    render(){
        const {open, toggle, className, confirmPayment, subscribtionSelected, subscriptionTypes, accountData, showLoader, currentSubscription} = this.props;
        const {isDowngrade} = this.state;
        console.log('accountData: ', accountData);
        console.log('currentSubscriptionConfirmation: ', currentSubscription);

        console.log('isDowngrade: ', isDowngrade);
        return (
            <CustomModal 
            heading= {'Abonnement abschließen'}  
            open={open} 
            toggle={toggle} 
            className={`${className}`}>
                <Stack gap={30}>
                 <Group>
                     <span style={{fontSize: '14px', color: '#454576', fontWeight: '400'}}>Bevor Sie das Abonnement abschließen, prüfen Sie bitte Ihre Angaben.</span>
                 </Group>
                 {subscriptionTypes.filter((subscriptionType)=> subscriptionType?.subscriptionTypeId === subscribtionSelected).map((subscriptionType)=> {
                 return (<Stack>
                    <Stack gap={5}>
                        <span className="payment-heading-main" style={{fontSize: '16px', marginBottom: '16px'}}>Abonnement</span>
                        <Group grow>
                            <div className='upgrade-subscription-card' style={{cursor: 'auto', marginTop: 0, height: 'auto', paddingBottom: '16px'}}>
                                {this.renderPriceBlock(subscriptionType)}
                            </div>
                        </Group>
                    </Stack>
                    <Group>
                        <span style={{fontSize: '14px', color: '#454576', fontWeight: '400'}}>{this.renderChangeText(subscriptionType)}</span>
                    </Group>
                 </Stack>)})}
                 <Stack gap={5}>
                    <span className="payment-heading-main" style={{fontSize: '16px', marginBottom: '16px'}}>Zahlungsmethode</span>
                    <Group grow>
                        {this.state.heading &&
                        <Stack gap={0} style={{border: '1px solid #DADAE5', marginBottom: '11px', borderRadius: '3px'}}>
                            <Stack style={{borderBottom: '1px solid #DADAE5', padding : '10px'}} gap={0}>
                                    <div style={{fontSize: '12px', color: '#727293', fontWeight: '400'}}>{'Zahlungsmittel'}</div>
                                    <div style={{fontSize: '14px', color: '#454576', fontWeight: '500'}}>{this.state.heading === 'creditcard' ? 'Kreditkarte' : this.state.heading === 'directdebit' ? 'Lastschrifteinzug' : 'Paypal'}</div>
                            </Stack>
                            {this.state.holderName &&
                            <Stack style={{borderBottom: '1px solid #DADAE5', padding : '10px'}} gap={0}>
                                    <div style={{fontSize: '12px', color: '#727293', fontWeight: '400'}}>{lang.general.text_Inhaber}</div>
                                    <div style={{fontSize: '14px', color: '#454576', fontWeight: '500'}}>{this.state.holderName}</div>
                            </Stack>}
                            <Group style={{ padding : '7px 10px'}} grow>
                                <Stack gap={5}>
                                    <div className="payment-head" style={{display: 'flex', justifyContent: 'space-between', width: '100%', fontSize: '12px', color: '#727293', fontWeight: '400'}}>
                                        {this.state.heading === 'directdebit' ? 'IBAN' : this.state.heading === 'creditcard' ? this.state.cardLabel : this.state.heading === 'paypal' ? 'Konto' : this.state.holderCardNo.split(' ')[0]}
                                    </div>
                                    <div className="payment-text" style={{fontSize: '14px', color: '#454576', fontWeight: '500'}}>{this.state.heading === 'directdebit' ? this.state.consumerAccount : this.state.heading === 'creditcard' ? `xxxx xxxx xxxx ${this.state.cardNumber}` : this.state.heading === 'paypal' ? this.state.consumerAccount : `xxxx xxxx xxxx ${this.state.holderCardNo.split(' ')[1]}`}</div>
                                </Stack>
                                <Group style={{justifyContent: 'flex-end'}}>
                                    {this.state.heading === 'directdebit' ? 
                                    <Group>
                                        {/* <img src={'https://www.mollie.com/external/icons/payment-methods/sofort.svg'}/> */}
                                        <img src={'https://www.mollie.com/external/icons/payment-methods/directdebit.svg'}/>
                                    </Group>
                                    :
                                    this.state.heading === 'creditcard' ? 
                                    <Group><img src={'https://www.mollie.com/external/icons/payment-methods/creditcard.svg'}/></Group>
                                    :
                                    this.state.heading === 'paypal' &&
                                    <Group><img src={'https://www.mollie.com/external/icons/payment-methods/paypal.svg'}/></Group>
                                    }
                                </Group>
                            </Group>
                            {this.state.consumerBic &&
                            <Stack style={{borderTop: '1px solid #DADAE5', padding : '7px 10px'}} gap={5}>
                                    <div className="payment-head" style={{fontSize: '12px', color: '#727293', fontWeight: '400'}}>{'BIC'}</div>
                                    <div className="payment-text" style={{fontSize: '14px', color: '#454576', fontWeight: '500'}}>{this.state.consumerBic}</div>
                            </Stack>}
                        </Stack>}
                    </Group>
                    <span style={{fontSize: '14px', color: '#454576', fontWeight: '400'}}>Bitte drücken Sie Bestätigen, um das Abonnement zu starten.</span>
                 </Stack>
                 
                 <Group grow>
                    <div style={{justifyContent: 'flex-end', display: 'flex'}}>
                        <div>
                        <ColorButton
                            text={'Bestätigen'}
                            className='purple-btn'
                            onClick={()=>{
                                confirmPayment();
                                toggle();
                            }}
                            showLoader={showLoader}
                        />
                        </div>
                    </div>
                 </Group>
                </Stack>
            </CustomModal>
         )
    }
}
const mapStateToProps = (state) => {
    return {
        propertySelected: state.generalReducer.property,
        profile: state.generalReducer.profile,
        AccountApi: state.generalReducer.account_api_id,
        accountData: state.generalReducer.accountData,
        currentSubscription: state.generalReducer.currentSubscription,
        hasTested: state.generalReducer.hasTested
    };
};

export default connect(mapStateToProps)(PaymentConfirmationModal);
